<template>
  <section class="image-carousel" v-if="imageList">
    <carousel v-bind:per-page="1"
              pagination-active-color="#00c896"
              pagination-color="rgba(0, 0, 0, 0.1)"
              v-bind:pagination-padding="6"
              v-bind:pagination-size="10"
              v-bind:autoplay-timeout="3000"
              v-bind:loop="true"
              v-bind:autoplay-hover-pause="true"
              v-bind:autoplay="true">
      <slide v-for="(image, index) in imageList" v-bind:key="index">
        <img v-bind:src="image" class="img-fluid">
      </slide>
    </carousel>
  </section>
</template>

<script>
  export default {
    name: 'image-carousel',

    props: {
      imageList: {
        type: Array,
        default: null,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ImageCarousel.vue